module.exports = __webpack_public_path__ + "static/zencircle_white-3714594598a3b1f8e274b93ecb1f801f.png";